"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const LabelLocation_1 = require("./LabelLocation");
const LabeledInputFieldWidget_1 = tslib_1.__importDefault(require("../widget/LabeledInputFieldWidget"));
// Component rendered in the user interface
// <div class="checkbox-field">
//   <input id="checkbox-id" type="checkbox">
//   <label for="checkbox-id">Checkbox på venstre side af label</label>
// </div>
class WCAGCheckbox extends LabeledInputFieldWidget_1.default {
    constructor(args) {
        super({
            ...args,
            inputType: "checkbox"
        });
        const { checkedInitially } = args;
        if (checkedInitially) {
            this.setValue(checkedInitially);
        }
    }
    parseFieldElementValue() {
        return this.getFieldElement().checked;
    }
    setFieldElementValue(value) {
        this.fieldElement.checked = value;
    }
    decorateLabeledInputFieldWidgetElement(args) {
        const { labelLocation = LabelLocation_1.LabelLocation.RIGHT } = args;
        this.element = document.createElement("div");
        this.element.classList.add("checkbox-field", "flex-row");
        if (labelLocation === LabelLocation_1.LabelLocation.LEFT) {
            this.fieldElement.classList.add("checkbox-on-left");
        }
        if (labelLocation === LabelLocation_1.LabelLocation.RIGHT) {
            this.add(this.fieldElement);
            this.add(this.labelElement);
        }
        else {
            this.add(this.labelElement);
            this.add(this.fieldElement);
        }
    }
}
exports.default = WCAGCheckbox;
//# sourceMappingURL=WCAGCheckbox.js.map